var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMute(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 550 450",
    style: {
      enableBackground: "new 0 0 550 450"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M352,16.1c0-6.1-3.5-11.8-9-14.4c-5.8-2.9-12.2-1.9-17,1.9l-141.8,113L352,284.2V16.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M443.3,420.7l-416-416C21.1-1.5,11-1.5,4.7,4.7s-6.2,16.4,0,22.6l100.7,100.7H96c-9.9,0-18.6,4.5-24.3,11.5 c-4.8,5.4-7.7,12.8-7.7,20.5v128c0,17.6,14.4,32,32,32h74.2l155.8,124.5c2.9,2.2,6.4,3.5,9.9,3.5c2.2,0,4.8-0.6,7-1.6 c5.4-2.6,9-8.3,9-14.4v-57.4l68.7,68.7c3.1,3.1,7.2,4.7,11.3,4.7s8.2-1.6,11.3-4.7C449.6,437.1,449.6,427,443.3,420.7z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMute);
export default __webpack_public_path__ + "static/media/mute.98ec6846f8fe952d55c3509f7d8b9b37.svg";
export { ForwardRef as ReactComponent };